import React, { useState, useEffect } from "react";
import AboutOne from "../section/about/AboutOne";
import BannerFour from "../section/banner/BannerFour";
import CtaFour from "../section/cta/CtaFour";
import { FeatureThree, FeatureThreeAlt, FeatureThreethree} from "../section/feature/FeatureThree";
import FooterThree from "../section/footer/FooterThree";
import Intro from "../section/intro/Intro";
import { useParams, useNavigate } from "react-router-dom";
import { TypeformResponse } from "../types";

const Results = (props) => {
  const { formId, resultId } = useParams();
  const navigate = useNavigate();

  const colour_bands = {
    "high": "#1ee0ac",
    "medium": "#f4bd0e",
    "low": "#e85347",
  };

  const getColour = (score: number) => {
    if (score >= 68) {
      return colour_bands["high"];
    } else if (score >= 34) {
      return colour_bands["medium"];
    } else {
      return colour_bands["low"];
    }
  }

  // live url
  const url = `https://texpertai-airtable-worker.celestify.workers.dev/api/result/${formId}/${resultId}`;
  // wrangler local url
  // const url = `http://localhost:8787/api/result/${formId}/${resultId}`;

  const [typeformResponse, setTypeformResponse] = useState<TypeformResponse>();
  const [result, setResult] = useState<any>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(url)
      .then((res) => {
        if (res.status >= 400) {
          navigate("/not-found");
        }
        return res.json();
      })
      .then((data) => {
        setTypeformResponse(data as TypeformResponse);
        setLoading(false);
      })
      .catch((err) => {
        navigate("/not-found");
      });
  }, []);

  // TODO: Make this dynamic in the future.
  const OVERALL_MAX_SCORE = 300;
  const SCOREDATA_1_MAX_SCORE = 150;
  const SCOREFRAMEWORK_2_MAX_SCORE = 50;
  const SCORESTRATEGY_3_MAX_SCORE = 100;

  useEffect(() => {
    if (typeformResponse) {
      // TODO: see testresponse.json for data format.
      const resultData = {
        category1: {
          label: "Data Analysis",
          value:
            typeformResponse?.variables.find((x) => x.key === "scoredata_1")
              .number / SCOREDATA_1_MAX_SCORE,
        },
        category2: {
          label: "Frameworks",
          value:
            typeformResponse?.variables.find(
              (x) => x.key === "scoreframework_2"
            ).number / SCOREFRAMEWORK_2_MAX_SCORE,
        },
        category3: {
          label: "Strategy",
          value:
            typeformResponse?.variables.find((x) => x.key === "scorestrategy_3")
              .number / SCORESTRATEGY_3_MAX_SCORE,
        },
        overallScore: {
          label: "Overall",
          value:
            (typeformResponse?.variables.find((x) => x.key === "score").number /
              OVERALL_MAX_SCORE) *
            100,
        },
        email: typeformResponse?.answers.find((x) => x.type === "email").email,
      };
      setResult(resultData);
    }
  }, [typeformResponse]);

  const data = [
    {
      id: result?.category1.label,
      value: result?.category1.value,
      color: getColour(result?.category1.value * 100),
    },
    {
      id: result?.category2.label,
      value: result?.category2.value,
      color: getColour(result?.category2.value * 100),
    },
    {
      id: result?.category3.label,
      value: result?.category3.value,
      color: getColour(result?.category3.value * 100),
    },
  ];

  if (loading) {
    return null;
  }

  return (
    <div className="nk-main">
      <BannerFour
        className="header-16 has-header-main-s1 bg-dark"
        categories={[
          {
            text: result?.category1.label,
            to: "#cat1",
          },
          {
            text: result?.category2.label,
            to: "#cat2",
          },
          {
            text: result?.category3.label,
            to: "#cat3",
          },
          {
            text: "Book a Demo",
            to: "#cta",
          },
        ]}
      />
      <Intro
        data={data}
        Email={result?.email}
        OverallScore={Math.round(result?.overallScore.value)}
      />
      <FeatureThree
        className="section-feature pb-5 bg-lighter"
        // style={{border: "1px solid grey", borderRadius: "10px"}}
        id="#cat1"
        title={result?.category1.label}
        score={Math.round(result?.category1.value * 100)}
      />
      <FeatureThreeAlt
        className="section-feature pb-5"
        // style={{border: "1px solid grey", borderRadius: "10px"}}
        id="#cat2"
        title={result?.category2.label}
        score={Math.round(result?.category2.value * 100)}
      />
      <FeatureThreethree
        className="section-feature bg-lighter"
        // style={{border: "1px solid grey", borderRadius: "10px"}}
        id="#cat3"
        title={result?.category3.label}
        score={Math.round(result?.category3.value * 100)}
      />
      <CtaFour className="section-cta" id="#cta" />
      <FooterThree className=" bg-dark is-dark section section-sm" />
    </div>
  );
};

export default Results;
